query GetCharityContacts($charityId: ID!) {
  charityContacts(charityId: $charityId) {
    id
    firstName
    surname
    email
    phone
    role
    portalStatus
    emailVerification {
      domain
      score
      shouldBlock
      fetchedAt
      notes
      riskLevel
      riskLevelNotes
      verificationStatus
    }
  }
}
